import { filter, find, has, lensProp, over, pipe } from 'ramda';
import type { AnySection, SectionItemBase } from '../../types/sections';
import type { GroupBase } from '../../types/groups';
import type { BaseClientEntities } from '../../fetchData';

const removeUnusedCategories = (entities: BaseClientEntities): BaseClientEntities =>
  over(
    lensProp('categories'),
    filter(
      // remove categories without `id` prop
      has('id'),
    ),
    entities,
  );

const removeUnusedGroups = (entities: BaseClientEntities): BaseClientEntities =>
  over(
    lensProp('groups'),
    filter(
      (group: GroupBase) =>
        Boolean(find((category) => group.categoryIds?.includes(category.systemId), entities.categories)) ||
        Boolean(
          find(
            (categoryOverride) => group.categoriesOverridesIds?.includes(categoryOverride.systemId),
            entities.categoriesOverrides,
          ),
        ),
    ),
    entities,
  );

const removeUnusedSections = (entities: BaseClientEntities): BaseClientEntities =>
  over(
    lensProp('sections'),
    filter<AnySection>(
      (section) =>
        Boolean(find((design) => section.panelDesignIds?.includes(design.systemId), entities.panelDesigns)) ||
        // Boolean(find((design) => section.panelDesignOverrideIds?.includes(design.systemId), entities.)) || ??
        Boolean(find((group) => section.groupIds?.includes(group.systemId), entities.groups)) ||
        Boolean(
          find((groupOverride) => section.groupOverrideIds?.includes(groupOverride.systemId), entities.groupsOverrides),
        ),
    ),
    entities,
  );

const removeUnusedItems = (entities: BaseClientEntities): BaseClientEntities =>
  over(
    lensProp('items'),
    filter<SectionItemBase>(
      (item) =>
        Boolean(find((section) => item.sectionIds?.includes(section.systemId), entities.sections)) ||
        Boolean(
          find(
            (sectionOverride) => item.sectionOverrideIds?.includes(sectionOverride.systemId),
            entities.sectionsOverrides,
          ),
        ),
    ),
    entities,
  );

export const removeUnusedEntities = pipe<
  BaseClientEntities,
  BaseClientEntities,
  BaseClientEntities,
  BaseClientEntities,
  BaseClientEntities
>(removeUnusedCategories, removeUnusedGroups, removeUnusedSections, removeUnusedItems);
